import styled from 'styled-components'
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Box,
  Tooltip,
} from '@mui/material'
import { StepsHeader } from '../../components'
import { useOnboarding } from '../../contexts/OnboardingContext'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;

  > span + span {
    margin-bottom: 16px;
  }
`

const Footer = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`

const MissionCritical = ({ onNext }) => {
  const { availableShift, workJourneyValues, setWorkJourneyValues } =
    useOnboarding()
  const { t } = useTranslation('common')

  const myShiftIsNotCorrect = {
    'my shift is not correct': t('onboarding.confirm_shift.incorrect'),
  }

  const shifts = availableShift.map(shift => {
    const { label } = shift

    if (myShiftIsNotCorrect[label]) {
      return {
        ...shift,
        label: myShiftIsNotCorrect[label],
      }
    }

    return shift
  })

  return (
    <Container>
      <ContentContainer>
        <StepsHeader
          stepText={t('onboarding.four_steps.one')}
          description={t('onboarding.confirm_shift.description')}
        />
        <FormContainer>
          <span style={{ fontSize: 24, fontWeight: 700 }}>
            {t('onboarding.confirm_shift.question')}
          </span>
          <span style={{ fontSize: 18, textAlign: 'center' }}>
            {t('onboarding.confirm_shift.input_request')}
          </span>
          <FormControl fullWidth>
            <InputLabel id='demo-simple-select-label'>
              {t('onboarding.confirm_shift.placeholder')}
            </InputLabel>
            <Select
              labelId='demo-simple-select-label'
              value={workJourneyValues}
              label={t('onboarding.confirm_shift.placeholder')}
              onChange={e => setWorkJourneyValues(e.target.value)}
            >
              {shifts.map(({ label, value }, index) => (
                <MenuItem
                  key={index}
                  value={value}
                >
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </FormContainer>
      </ContentContainer>
      <Footer>
        <Box />
        {!!!workJourneyValues ? (
          <Tooltip
            title={t('onboarding.confirm_shift.stop_action')}
            placement='top'
            arrow
          >
            <span>
              <Button
                variant='contained'
                disabled
              >
                {t('onboarding.advance')}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            variant='contained'
            onClick={onNext}
          >
            {t('onboarding.advance')}
          </Button>
        )}
      </Footer>
    </Container>
  )
}

export default MissionCritical
